// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/sdpMerchant';

/** 支付宝PID修改 POST /mch/alipay/pid/modify */
export async function alipayPidModify(
  body: APISdpMerchant.AlipayPidModifyApiRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/alipay/pid/modify', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 授权商户分页查询 POST /mch/auth/mch/page/query */
export async function mchPageQuery(
  body: APISdpMerchant.AuthMchPageQueryRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayPageResponseAuthMchVO_>('/mch/auth/mch/page/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 商户基本信息查询 POST /mch/base/query */
export async function mchBaseQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseMerchantVO_>('/mch/base/query', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 查询当前商户受益人待补充数据 POST /mch/beneficiary/query */
export async function mchBeneficiaryQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayListResponseCommonBeneficiaryVO_>('/mch/beneficiary/query', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 商户注销申请 GET /mch/cancel/apply */
export async function mchCancelApply(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseMchCancelApplyDetailVO_>('/mch/cancel/apply', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 商户注销申请查询 GET /mch/cancel/apply/query */
export async function cancelApplyQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseMchCancelApplyDetailVO_>(
    '/mch/cancel/apply/query',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 渠道受益人查询 GET /mch/channel/ubo/query */
export async function channelUboQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayListResponseString_>('/mch/channel/ubo/query', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 商户联系人信息查询-明文 POST /mch/contact/query */
export async function mchContactQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseContactInfoVO_>('/mch/contact/query', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 跨进商户判断 GET /mch/cross/check */
export async function mchCrossCheck(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseBoolean_>('/mch/cross/check', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 查询商户待修改资质更新数据列表 POST /mch/license/query */
export async function mchLicenseQuery(
  body: APISdpMerchant.ApiBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayListResponse2>('/mch/license/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 机构子商户基本信息查询 当前商户作为总部商户时，查询其下的子商户 POST /mch/sub/base/query */
export async function subBaseQuery(
  body: APISdpMerchant.MerchantIdRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayDataResponseMerchantVO_>('/mch/sub/base/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 机构子商户联系人信息查询-明文 POST /mch/sub/contact/query */
export async function subContactQuery(
  body: APISdpMerchant.MerchantIdRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayDataResponseContactInfoVO_>('/mch/sub/contact/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

